class SdPatchAddToCart extends HTMLElement {
  constructor() {
    super();
    this.onBundleOfferChange = this.onBundleOfferChange.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);
  }

  connectedCallback() {
    this.variantInput = this.querySelector('input.product-variant-id[name="id"]');
    this.priceEl = this.querySelector('[data-sd-patch-atc-price]');
    this.button = this.querySelector('.sd-patch-atc__cta[type="submit"]');
    this.availableEl = this.querySelector('[data-sd-patch-atc-available]');
    this.soldOutEl = this.querySelector('[data-sd-patch-atc-soldout]');
    this.variants = this.parseVariants();

    document.addEventListener('sd:bundle-offer-change', this.onBundleOfferChange);

    if (typeof subscribe === 'function') {
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
    }

    this.syncFromBundle();
  }

  disconnectedCallback() {
    document.removeEventListener('sd:bundle-offer-change', this.onBundleOfferChange);
    this.variantChangeUnsubscriber?.();
  }

  parseVariants() {
    const script = this.querySelector('[data-sd-patch-atc-variants]');
    if (!script) return {};

    try {
      return JSON.parse(script.textContent) || {};
    } catch {
      return {};
    }
  }

  getVariant(variantId) {
    if (!variantId) return null;
    return this.variants[String(variantId)] || null;
  }

  syncFromBundle() {
    const selected = document.querySelector(
      'sd-product-bundle-v2 [data-bundle-item].is-selected, sd-product-bundle [data-bundle-item].is-selected'
    );

    if (!selected) return;

    const priceEl = selected.querySelector('[data-sd-bundle-v2-price], [data-sd-bundle-price]');
    this.applyOffer({
      variantId: selected.dataset.variantId,
      price: priceEl?.dataset.sdStaticValue || priceEl?.textContent.trim() || '',
      available: selected.dataset.variantAvailable !== 'false',
    });
  }

  onBundleOfferChange(event) {
    const { variantId, price, available } = event.detail || {};
    if (!variantId || !this.getVariant(variantId)) return;

    this.applyOffer({ variantId, price, available });
  }

  onVariantChange({ data } = {}) {
    const variantId = data?.variant?.id;
    if (!variantId || !this.getVariant(variantId)) return;

    this.applyOffer({
      variantId,
      available: data.variant.available !== false,
    });
  }

  applyOffer({ variantId, price, available }) {
    const variant = this.getVariant(variantId);
    if (!variantId || !variant) return;

    const nextPrice = price || variant.price || '';
    const nextAvailable = available ?? variant.available ?? true;

    if (this.variantInput) {
      this.variantInput.value = String(variantId);
      this.variantInput.disabled = !nextAvailable;
    }

    if (this.priceEl && nextPrice) {
      this.priceEl.textContent = nextPrice;
    }

    if (this.button) {
      this.button.disabled = !nextAvailable;
    }

    if (this.availableEl) {
      this.availableEl.hidden = !nextAvailable;
    }

    if (this.soldOutEl) {
      this.soldOutEl.hidden = nextAvailable;
    }
  }
}

if (!customElements.get('sd-patch-atc')) {
  customElements.define('sd-patch-atc', SdPatchAddToCart);
}
